import { useState, useEffect } from "react";
import axios from "axios";
import { Badge } from "@/components/ui/badge";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } });

export default function AdminWhatsAppLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/admin/whatsapp-logs`, authHeaders()).then(r => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-whatsapp-logs">
      <h1 className="font-heading text-2xl tracking-tight font-medium mb-6">WhatsApp Logs ({logs.length})</h1>
      <div className="space-y-2">
        {logs.map((log, i) => (
          <div key={log.id || i} className="bg-card border border-border/40 rounded-sm p-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="font-medium text-sm">{log.recipientNumber}</span>
                  <Badge variant={log.sendStatus === "sent" ? "default" : "destructive"} className="text-[10px] rounded-full">{log.sendStatus}</Badge>
                  <Badge variant="secondary" className="text-[10px] rounded-full">{log.templateType}</Badge>
                  <Badge variant="outline" className="text-[10px] rounded-full">{log.userType}</Badge>
                </div>
                <p className="text-xs text-muted-foreground">
                  SID: {log.messageSid || "N/A"} / {new Date(log.createdAt).toLocaleString()}
                  {log.errorMessage && <span className="text-destructive ml-2">Error: {log.errorMessage}</span>}
                </p>
              </div>
            </div>
          </div>
        ))}
        {logs.length === 0 && <p className="text-sm text-muted-foreground py-8 text-center">No WhatsApp logs yet</p>}
      </div>
    </div>
  );
}
